<div>
    <a href="https://mytidy.it" class="text-center" style="display:block; color: black; font-weight: bold; font-size: 12px;">
        <span style="padding-top: 2px; vertical-align: sub">Powered by&nbsp;</span><img width="32" height="32" src="/assets/images/mytidy.png">
    </a>

    <div class="text-center" style="margin: 30px;">
        <div style="font-size: 24px; font-weight: 700; color: black">{{store.name}}</div>
    </div>

    <div class="block">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-9 col-lg-6 d-flex">
                    <div class="card flex-grow-1 mb-md-0">
                        <div class="card-body">
                            <h3 class="card-title text-center">Accedi come amministratore</h3>
                            <form [formGroup]="loginForm">
                                <div class="form-group">
                                    <label>Email</label>
                                    <input type="email" class="form-control" placeholder="Email"
                                        formControlName="username">
                                    <small *ngIf="isControlHasError('username'); let error"
                                        class="text-danger">{{error}}</small>
                                </div>
                                <div class="form-group">
                                    <label>Password</label>
                                    <div class="input-group">
                                        <input type="password" class="form-control"
                                            placeholder="Password" formControlName="password">
                                        <span (click)="togglePassword($event)"
                                            class="fa fa-fw fa-eye toggle-password"></span>
                                    </div>
                                    <small *ngIf="isControlHasError('password'); let error"
                                        class="text-danger">{{error}}</small>
                                </div>
                                <div class="form-row justify-content-center">
                                    <button type="submit" (click)="submit()"
                                        class="btn btn-primary-darken mt-2 mt-md-3 mt-lg-4"
                                        [ngClass]="{'btn-loading': loading}">Accedi</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>